import { render, staticRenderFns } from "./cardListCategory.vue?vue&type=template&id=228b4283&scoped=true&"
import script from "./cardListCategory.vue?vue&type=script&lang=js&"
export * from "./cardListCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b4283",
  null
  
)

export default component.exports